<template>
    <div class="artcleMain">
        <p class="current">当前位置：<span>安全培训</span></p>
        <div class="artcle-box">
            <div class="menu" v-show="widthNew">
                <el-menu
                    ref="menu"
                    class="el-menu-vertical-demo"
                    default-active="1"
                    background-color="#fff"
                    active-text-color="#00a8a8">
                        <el-menu-item index="1"  @click="handleMenu(id='')">全部</el-menu-item>
                        <el-menu-item v-for="item,index in menuList" :key="item.cate_id" :index="2+index.toString()" @click="handleMenu(item.cate_id)">{{ item.cate_name }}</el-menu-item>
                     
                
                </el-menu>
            </div>
            <div class="infoNav4"  v-show="!widthNew">
                <ul>
                    <li class="slotPoper" @click="handleMenu(id='')" :class="active== -1?'slotPoperColor':''">全部</li>
                    <li class="slotPoper"  @click="handleMenu(item.cate_id,index)"
                        :class="index==active?'slotPoperColor':''"
                        v-for="item,index in menuList" :key="item.cate_id" :index="2+index.toString()">{{ item.cate_name }}</li>
                </ul>
            </div>
            <div class="artcle-right">
                <div class="search-page">
                    <Search  class="searchWidth" @inputKey="inputKey"></Search>
                </div>
                <div class="listMain">
                    <div v-for="item in listTrain" :key="item.id" class="listItem">
                        <div @click="getTrainInfo(item)" :style="'background-image:url('+item.firstFile.FileUrl+');background-size: cover;background-repeat: no-repeat;background-position: center;'"></div>
                        <p class="ItemName"  @click="getTrainInfo(item)">{{ item.name }}</p>
                        <el-button @click="Application(item)">立即报名<span>￥{{ item.price }}</span></el-button>
                        
                    </div>
                </div>
                
                       
            </div>
            <div class="pagination">
                    <el-pagination
                        :hide-on-single-page="hideOnSinglePage"
                        :page-size="20"
                        :pager-count="widthNew?11:5"
                        @current-change="handleCurrentChange"
                        layout="prev, pager, next"
                        :total="total">
                    </el-pagination>
                </div>
          
        </div>
    </div>
</template>

<script>
import Search from "../search/index.vue"
export default({
    data(){
        return{
            menuList: [],
            listTrain: [],
            total: 0,
            hideOnSinglePage: true,
            keywords: '',
            cate_id: '',
            widthNew: false,
            active: -1
        }
    },
    components: {
        Search,
    },
    watch: {
    
      
    },
    methods:{
        getmMnuList(data){
            this.$store.dispatch('menu/menuList',data)
                .then(res => {
                    console.log('getmMnuList')
                    console.log(res)
                    if(res.ok){
                        this.menuList = res.data.items
                    }
                })
        },
        getListTrain(data){
            this.$store.dispatch('train/listTrain',data)
                .then(res =>{
                    if(res.ok){
                        this.listTrain = res.data.items
                        this.total = res.data.total

                        if(this.total <= 20){
                            this.hideOnSinglePage = true
                        }else{
                            this.hideOnSinglePage = false
                        }
                    }
                })
        },
        handleMenu(id,index){
            this.active = index
            console.log(id);
            this.cate_id = id
            let listTrain = {
                pageNum: 1,
                pageSize: 20,
                cate_ids: id,
                keywords: this.keywords
            }
            this.getListTrain(listTrain)
        },
        inputKey(val){
            this.keywords = val
            let listTrain = {
                pageNum: 1,
                pageSize: 20,
                cate_ids: this.cate_id,
                keywords: val
            }
            this.getListTrain(listTrain)
        },
        handleCurrentChange(val){
            console.log(`当前页: ${val}`);
            let listTrain = {
                pageNum: 1,
                pageSize: 20,
                cate_ids: this.cate_id,
                keywords: this.keywords
            }
            this.getListTrain(listTrain)
        },
        getTrainInfo(item){
            console.log(item);
            
            const { href } = this.$router.resolve({
                path: "/trainInfo",
                query: {
                    key: item.id,
                }
            });
            window.open(href, '_blank');
        },
        Application(item){
            const { href } = this.$router.resolve({
                path: "/application",
                query: {
                    key: item.id,
                }
            });
            window.open(href, '_blank');
        }
    },
    mounted(){
        
    },
    
    created(){
        let widthNew = document.documentElement.clientWidth
        if(widthNew > 540){
            this.widthNew = true
        }else{
            this.widthNew = false
        }
        let data = {
            pageNum: 1,
            pageSize: 999999,
            cate_values: 'train',
            //parent_cate_value: 'train'
        }
        this.getmMnuList(data)
        
        let listTrain = {
            pageNum: 1,
            pageSize: 20,
            cate_ids: '',
            keywords: ''
        }
        this.getListTrain(listTrain)
      
    }
})
</script>

<style>
@import url(../../css/channelPolicy.css);
</style>

<style scoped>
 .searchWidth{
        margin-bottom: 40px;
        width: 600px;
    }
.listMain{
    display: flex;
    justify-content: flex-start;
    flex-flow: row wrap;
    align-items: center;
    margin-top: 10px;
    background: #fff;
    
}
.listItem{
    width: 270px;height: 295px;
    margin: 10px 15px 15px 15px;
    cursor: pointer;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
}
.listItem div{
    width: 270px;height:190px
}
.ItemName{
    margin-top: 10px;
    font-size: 18px;
    margin-left: 6px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    cursor: pointer;
}
.listMain .el-button{
    background: #00acc9;
    color: #fff;
    width: 100%;
    margin-top: 28px;
}
.search-page{
    padding: 10px 0 10px 15px;
    background: #fff;
    height: 45px;
}

@media screen and (max-width: 540px) {
   
    .searchWidth{
        padding-left: 0px;
        margin-bottom: 40px;
        width: 95%
    }

    .listItem{
        width: 95%;height: 295px;
        margin: 10px 15px 15px 15px;
        cursor: pointer;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
    }
    .listItem div{
        width: 100%;height:190px
    }

    .ItemName{
        font-size: 16px;
    }
}
</style>